// src/features/auth/components/LoginForm.js
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import Input from '../../../shared/components/Input';
import Button from '../../../shared/components/Button';
import { useAuth } from '../hooks/useAuth';


const schema = yup.object({
  username: yup.string().required('Username/Email/Mobile is required'),
  password: yup.string().required('Password is required'),
  remember: yup.boolean(),
});

const LoginForm = () => {
  const { login, isLoading, error, clearError } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    await login(data);
  };

  return (
    <div className="max-w-md w-full mx-auto">
      <div className="text-center mb-8">
        <img 
  src="/avyukt-healthcare-logo.png" 
  alt="Logo" 
  className="mx-auto h-16 w-auto mb-4"
/>
        {/* <h2 className="text-3xl font-bold text-gray-900">Welcome Back</h2> */}
        <p className="text-gray-600 mt-2">Sign in to your OHCMS account</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
          <button onClick={clearError} className="float-right">×</button>
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <Input
          label="Username or Email or Mobile No."   // You can keep label same if needed
          type="text"
          {...register('username')}
          error={errors.username?.message}
          placeholder="Enter your username/email/mobile No."
        />

        <Input
          label="Password"
          type="password"
          {...register('password')}
          error={errors.password?.message}
          placeholder="Enter your password"
        />

        <div className="flex items-center justify-between">
          <label className="flex items-center">
            <Input
              type="checkbox"
              {...register('remember')}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <span className="ml-2 text-sm text-gray-700">Remember me</span>
          </label>

          <Link
            to="/forgot-password"
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            Forgot password?
          </Link>
        </div>

        <Button
          type="submit"
          variant="primary"
          isLoading={isLoading}
          className="w-full"
        >
          Sign In
        </Button>
      </form>

      {/* <p className="mt-6 text-center text-sm text-gray-600">
        Don't have an account?{' '}
        <Link to="/register" className="text-blue-600 hover:text-blue-800 font-medium">
          Register here
        </Link>
      </p> */}
    </div>
  );
};

export default LoginForm;